import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { mediaQueries } from '@blazar-plugins/device'

export const ListWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
`

export const List = styled.ul`
  margin-top: 4px;
  font-family: 'BlocketSans-Regular', sans-serif;
  line-height: 20px;
  color: #696766;
  font-size: 12px;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
  flex-grow: 1;
  text-overflow: ellipsis;
  word-break: break-word;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  hyphens: auto;

  @media ${mediaQueries.medium} {
    font-size: 15px;
  }
`

export const ListItem = styled.li`
  display: inline;
  &:not(:last-child)::after {
    content: '·';
    display: inline-block;
    margin: 0 0.25em;
  }
`

export default function ParametersList({ parameters }) {
  return (
    <ListWrapper>
      <List>
        {parameters.map((param) => (
          <ListItem key={param}>{param}</ListItem>
        ))}
      </List>
    </ListWrapper>
  )
}

ParametersList.propTypes = {
  parameters: PropTypes.array.isRequired,
}
